<template>
    <div ref="cf" class="text-dark">
        <button @click="show = !show" class="page-link category-filter-button">Filter&nbsp; <font-awesome-icon :icon="show ? 'angle-down' : 'angle-up'" /></button>
        <span v-for="(category) in selected" class="badge badge-light mx-1 p-2">{{ category.label }}</span>
        <div v-if="show" class="category-filter-list">
            <h6 v-if="title" class="category-filter-list-title">{{ title }}</h6>
            <ul class="category-filter-list-group">
                <li v-for="(category, index) in categories" class="category-filter-list-group-item">
                    <input :id="`filter_option_${index}`" type="checkbox" @change="filter" :value="category.value" :checked="selected.includes(category)"
                        :disabled="!selected.includes(category) && selected.length === categories.length - 1">
                    <label :for="`filter_option_${index}`" class="text-dark ml-2">{{ category.label }}</label>
                </li>
            </ul>
            <button class="page-link category-filter-clear-button" @click="clearSelection" :disabled="this.selected.length === 0">Clear</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategoryFilter',
    data() {
        return {
            show: false,
            selected: [],
        }
    },
    props: {
        title: { type: String },
        categories: { type: Array, required: true },
    },
    watch: {
        show: function() {
            if (this.show) {
                document.addEventListener('click', this.clickedSomewhere, { capture: true });
            }
            else {
                document.removeEventListener('click', this.clickedSomewhere, { capture: true });
            }
        }
    },
    methods: {
        clickedSomewhere(event) {
            const withinThisComponent = event.composedPath().includes(this.$refs.cf);
            if (!withinThisComponent) {
                this.show = false;
            }
        },
        clearSelection() {
            this.selected = [];
            this.$emit('filter', this.selected);
        },
        categoryForValue(value) {
            return this.categories.find(e => e.value === value);
        },
        filter(e) {
            const category = this.categoryForValue(e.target.value);

            // categories and selected are both lists of objects { value, label }
            if (this.selected.includes(category)) {
                this.selected.splice(this.selected.indexOf(category), 1);
            }
            else {
                this.selected.push(category);
            }

            // Everything selected is equivalent to no filters at all
            if (this.selected.length === this.categories.length) {
                this.$emit('filter', []);
            }
            else {
                this.$emit('filter', this.selected);
            }
        },
    },
    expose: ['clearSelection'],
}
</script>
<style scoped>
.category-filter-list {
    border-radius: 6px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    background-color: #fff;

    color: #66615B;
    margin-top: 6px;
    margin-bottom: 20px;
    position: absolute;
    z-index: 10;
    border: none;
    font-size: 14px;
}
.category-filter-list-title {
    text-align: center;
    text-transform: uppercase;
    padding: 0.25rem 1.25rem;
}
.category-filter-list-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: 0.25rem;
}
.category-filter-list-group-item {
    color: #66615B;
    /* border: 1px solid rgba(0, 0, 0, 0.125); */
    position: relative;
    display: block;
    padding: 0.25rem 1.25rem;
}
.category-filter-button {
    position: relative;
    display: inline;
    width: 120px;
    padding: 0.5rem 0.75rem;
    line-height: 1.25;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}
.category-filter-clear-button {
    position: relative;
    display: block;
    margin: 0.25rem auto;
    width: 60px;
    padding: 0.25rem 0.25rem;
    line-height: 1.25;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

</style>
